import Transition from 'react-addons-css-transition-group';
import React, { PropTypes } from 'react';
import './styles.scss';

export const Fade = props => (
  <Transition
    component='div'
    className={props.className}
    transitionName='fade'
    transitionAppear={false}
    transitionEnterTimeout={150}
    transitionLeaveTimeout={150}
  >
    {props.children}
  </Transition>
);

Fade.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

export default Fade;



// WEBPACK FOOTER //
// ./src/components/transitions/fade/index.jsx